/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>女头像审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">
      <el-form-item prop="accountId"  label="用户UID">
        <el-input  clearable v-model="formInline.accountId" placeholder="输入用户UID"></el-input>
      </el-form-item>
      <el-form-item prop="nickName" label="用户昵称">
        <el-input  clearable v-model="formInline.nickName" placeholder="输入用户昵称"></el-input>
      </el-form-item>


      <el-form-item   prop="operatorUserId" label="审核人员">
        <el-select clearable   v-model="formInline.operatorUserId" placeholder="请选择">
    <el-option

      v-for="item in SelectList"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
      </el-form-item>
<el-form-item label="提交时间" prop="beginCreateTime">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginCreateTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
        <el-form-item prop="endCreateTime"  style="margin-left: 0px;" label="">
            <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"   default-time="['23:59:59']"   type="datetime" placeholder="选择日期" v-model="formInline.endCreateTime" style="width: 100%;"></el-date-picker>
        </el-form-item>


    </el-col>
  </el-form-item>
  <el-form-item  prop="beginAge"  label="年龄" >
    <el-input  style="width: 80px;" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>-
      <el-form-item prop="endAge">
        <el-input   style="width: 80px;" prop="endAge" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
      </el-form-item>
  </el-form-item>
  <el-form-item  prop="beginAppearanceScore"  label="颜值分数">

      <el-input   style="width: 80px;" clearable  v-model="formInline.beginAppearanceScore" placeholder="不限"></el-input> -

        <el-form-item prop="endAppearanceScore"   label="">
           <el-input  clearable  style="width: 80px;" v-model="formInline.endAppearanceScore" placeholder="不限"></el-input>
          </el-form-item>


  </el-form-item>
  <el-form-item prop="isVip"  label="vip类型:">
    <el-select v-model="formInline.isVip" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="线下超级会员" value="1"></el-option>
      <el-option label="线上VIP" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="isRealFace"  label="是否是真颜用户:">
    <el-select v-model="formInline.isRealFace" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="是" value="1"></el-option>
      <el-option label="否" value="0"></el-option>

    </el-select>
  </el-form-item>

<div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">

  <el-button  type="success" icon="el-icon-thumb"   @click="caozClick">操作</el-button>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-delete"  @click="resetForm('formInline')">重置</el-button>
  <!-- <el-button  type="primary"  @click="caozClick">操作</el-button>
          <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->

        </div>
    </el-form>


    <el-tabs v-model="activeName" style="width: 20%;"  @tab-click="handleClick">
    <el-tab-pane label="待审核" name="1"></el-tab-pane>
    <el-tab-pane label="审核通过" name="2"></el-tab-pane>
    <el-tab-pane label="审核未通过" name="3"></el-tab-pane>

  </el-tabs>
<el-table       id="educe-table"  ref="multipleTable"     stripe :data="listData" highlight-current-row v-loading="loading"

  @select-all="selectall"  @select="select" border element-loading-text="拼命加载中" style="width: 100%;  font-size: 18px;">
    <el-table-column  align="center" type="selection" width="60">
    </el-table-column>
    <el-table-column   align="center" prop="phone" label="UID" width="150">
      <template slot-scope="scope">
        <img style="width:50%;" v-if="scope.row.isVip==1" src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
        <div style="font-size: 29px; font-weight: 600; color: #9A75E4;">{{scope.row.id}}</div>
        <br><img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;" src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png" alt="">
        <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
      </template>

    </el-table-column>
    <el-table-column   prop="headIcon"  align="center" label="最新头像" width="180">
      <template slot-scope="scope">
        <el-image
      style="width: 130px; height: 130px; border-radius: 5px;"
      :src="scope.row.headIcon"

    :preview-src-list="[scope.row.headIcon]"/>
    <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.status==1">(待审核)</span>
      <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.status==2">(审核通过 {{scope.row.appearanceScore||''}}  {{scope.row.appearanceScore?'分':""}})</span>
      <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.status==3">(审核不通过)</span>
      </template>
    </el-table-column>
    <el-table-column   align="center" prop="headIcon" label="历史头像" width="190">
      <template slot-scope="scope">
        <el-image
        @click="historyHeadIcons(scope.row.historyHeadIcons)"
      style="width: 130px; height: 130px; border-radius: 5px;"
      :src="scope.row.historyHeadIcons[0].headIcon"/>

      </template>
    </el-table-column>
    <el-table-column prop="content"  align="center" label="真颜图片/视频" width="200">
      <template slot-scope="scope">
        <a :href="scope.row.realHeadIcon" v-if="scope.row.voucherType==2||scope.row.voucherType==4">
<video style="width: 150px;height: 150px; position: relative;" :src="scope.row.realHeadIcon"></video>
<img  style="width: 80px; height: 80px; position: absolute;   top:30%; left: 60px;" src="https://test-cos.ynhlminiapp.com/7ea8dd90-46ac-4dd2-834a-82c445b6b930.png" alt="">
</a>
<el-image
v-else-if="scope.row.voucherType==1||scope.row.voucherType==3"
        style="width: 130px; height: 130px; "
        :src="scope.row.realHeadIcon?scope.row.realHeadIcon:'https://test-cos.ynhlminiapp.com/accountDefaultHeadIcon.png'"

      :preview-src-list="[scope.row.realHeadIcon]"/>
      <span v-else>非真颜用户</span>
    <div>

    </div>

      </template>
    </el-table-column>
    <!-- <el-table-column  prop="realHeadIcon"  align="center" label="真颜头像" width="180">
      <template slot-scope="scope">
        <el-image
        v-if="scope.row.realHeadIcon"
      style="width: 130px; height: 130px; border-radius: 5px;"
      :src="scope.row.realHeadIcon"
    :preview-src-list="[scope.row.realHeadIcon]"/>
      </template>

    </el-table-column> -->



    <el-table-column   align="center" prop="sex" label="性别" width="70">
      <template slot-scope="scope">
        <div style="color: hotpink;">{{scope.row.sex==1?'男':"女"}}</div>
      </template>
    </el-table-column>
    <el-table-column   align="center" prop="nickName" label="昵称" width="150">
      <template slot-scope="scope">
        <div>{{scope.row.nickName}}</div><br>

      </template>
    </el-table-column>
    <el-table-column   align="center" prop="age" label="年龄" width="100">
    </el-table-column>


    <el-table-column  align="center"  prop="registerAddress" label="注册地区" width="250">

  </el-cascader>

    </el-table-column>

    <el-table-column v-if="activeName==2 ||activeName==3"  prop="checkUserName" label="审核人" width="150">
    </el-table-column>
    <el-table-column v-if="activeName==2 ||activeName==3"  prop="version" label="审核时间" width="250">
      <template slot-scope="scope">
        <div>{{scope.row.headIconCheckTimeMills|timestampToTime}}</div>
      </template>
    </el-table-column>
    <el-table-column  align="center"prop="registerTypeDesc" label="注册类型" width="180">
</el-table-column>
    <el-table-column   align="center" prop="registerIpAddress" label="登录ip地区" width="250">
    </el-table-column>

    <el-table-column  prop="version"  align="center" label="提交时间">
      <template slot-scope="scope">
        <div>{{scope.row.createTime|timestampToTime}}</div>
      </template>
    </el-table-column>



    <!-- <el-table-column align="center" label="操作" min-width="300">
      <template slot-scope="scope">
        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column> -->
  </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm"   style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"  @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;">
      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <!-- <el-button @click="selectalls(listData)" type="primary">全选</el-button> -->
      <!-- <el-button @click="imporList" type="success">导出数据</el-button> -->

    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input  v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input  v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <span>确定导出用户数据？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>


<!-- 弹出框 -->
<!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

<el-dialog title="颜值打分" @close="dialogFormVisiblefooter" :visible.sync="dialogFormVisible">
  <el-form >

    <el-radio-group v-model="radio">
    <el-radio :label="-1">审核未通过</el-radio>
    <el-radio :label="10">10</el-radio>
    <el-radio :label="20">20</el-radio>
    <el-radio :label="30">30</el-radio>
    <el-radio :label="40">40</el-radio>
    <el-radio :label="50">50</el-radio>
    <el-radio :label="60">60</el-radio>
    <el-radio :label="70">70</el-radio>
    <el-radio :label="80">80</el-radio>
    <el-radio :label="90">90</el-radio>
    <el-radio :label="100">100</el-radio>
  </el-radio-group>

  <el-form-item label="是否开启图片遮罩层:" v-if="radio==-1" >
    <el-switch v-model="isisMasking" ></el-switch>
  </el-form-item>


  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisiblefooter">取 消</el-button>
    <el-button type="primary" @click="YZdialogFormVisible">确 定</el-button>
  </div>
  </el-dialog>
  <!-- 查看历史用户头像 -->

  <el-dialog title="用户上传照片记录" :visible.sync="dialogFormVisibleicn">
  <div class="dialogForm" >
    <div class="dialogFormChl"  v-for="item in historyHea">
     <img :src="item.headIcon" alt="">
     <span v-if="item.status==1">待审核</span>
     <span v-if="item.status==2">审核通过</span>
     <span v-if="item.status==3">不通过</span> <br>

     <span>
      提交日期
      {{ item.operatorTime|timestampToTime}}
     </span> <br>
   <span>
    审核人员
    {{ item.operatorUserName ||'' }}
   </span><br>
   <span>审核日期{{
   item.operatorTime|timestampToTime
    }}</span>

    </div>
  </div>

</el-dialog>
</div>
</template>

<script>

import { deptList, deptSave,deptDelete} from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
let tokenId= localStorage.getItem('tokenId');
import Vue from 'vue'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      isisMasking:false,
      ssoServer:"",
      dialogVisible: false,
      dialogFormVisibleicn:false,
      ifShowbar:1,
      activeName: '1',
      radio:"",
      cityOptions:[{
        name:"审核未通过",
        lis:-1,

      },{
        name:"10",
        lis:10,

      },{
        name:"20",
        lis:20,

      },{
        name:"30",
        lis:30,

      },{
        name:"40",
        lis:40,

      },{
        name:"50",
        lis:50,

      },{
        name:"60",
        lis:60,

      },{
        name:"70",
        lis:70,

      },{
        name:"80",
        lis:80,

      },{
        name:"90",
        lis:90,

      },{
        name:"100",
        lis:100,

      }],
      dialogFormVisible:false,
      checkList: [],
      options123 : [],
      options1234123:[],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList:[],
      SelectList:"",
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      options: [{
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        },{
          value: 6,
          label: '博士后'
        },{
          value: 7,
          label: '博士后'
        }],
        source:[{
          value: 1,
          label: '网站注册'

        },{
          value: 2,
          label: '人工录入'

        },{
          value: 3,
          label: '资源导入'

        },{
          value: 4,
          label: '相亲活动'

        },{
          value: 5,
          label: '手机来电'

        },{
          value: 6,
          label: '表单填写'

        },{
          value: 7,
          label: '到店咨询'

        }],
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        isVip:"",
        beginAppearanceScore:"",
        isRealFace:"",//是否是真颜用户
        endAppearanceScore:"",
                operatorUserId:"",
        endRegisterTime:"",
        historyHea:"",
        accountId:"",
        registerAddress:'',
        version:"",
        beginCreateTime:"",
        status:1,
        endCreateTime:"",
        education:"",
        registerIpAddress:"",
        beginRegisterTime:"",
        searchType:"",
        source:"",
          sex:2,
        nickName:"",
        phone:"",
        beginAge:"",
        endAge:"",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      adder:"",
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer

    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId


    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    // this.getAddress()
    // this.getAddresss()
    Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-user/getSelectList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.SelectList =res.data.data
        console.log(res);

      })



   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dialogFormVisiblefooter(){
      this.isisMasking='0'
      this.dialogFormVisible=false
      this.radio=''
    },
  // 查看历史图片
  historyHeadIcons(item){
    this.historyHea =item
    console.log(item);
    this.dialogFormVisibleicn=true

  },
    // 颜值打分
    YZdialogFormVisible(){
      setTimeout(() => {
          if(!this.radio){
        this.$message({
         type: 'warning',
         message: '选择不能为空'
       })
       return
      }
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if(this.isisMasking){
        this.isisMasking=1
      }else{
        this.isisMasking=0
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
          isMasking:this.isisMasking,
          appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
         type: 'success',
         message: '打分成功'
       })

       this.formInline.current=1
       this.isisMasking='0'
       this.radio=''
       this.importList=[]
       this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })


          loading.close();
        }, 500);

    },
    handleCheckedCitiesChange(){
      console.log(this.checkList);
    },
    caozClick(){
      if(this.importList.length==0){
        this.$message({
         type: 'warning',
         message: '请选择要打分的用户'
       })
       return

      }else{
        this.dialogFormVisible=true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
      this.formInline.current=1
    //  return  console.log(this.activeName);
     if(this.activeName==1){
      this.formInline.status=1
        this.formLIst()
     }else if(this.activeName==2){
      this.formInline.status=2
        this.formLIst()
     }else if(this.activeName==3){
      this.formInline.status=3
        this.formLIst()
     }

      },

    getAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {

        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },
    selectallsif(){
      this.ifShowbar=1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList=[]
    },
    selectalls(rows) {

     this.ifShowbar=2
      //  return console.log("rows : "+JSON.stringify(rows));
      if (rows) {
        let data =[]
        rows.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

        rows.forEach(row => {


          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {

        this.$refs.multipleTable.clearSelection();//清除全选
      }
      console.log(rows);
    },
    // checkChange(a,b){
    //   console.log(a,b);

    // },




              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    selectall(val){

      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

      // this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      if(this.importList.length==0){

       this.$message({
         type: 'warning',
         message: '请选择要导出的数据'
       })
       return

     }else{
             Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/exportExcel',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importList
 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = res.headers['content-disposition'].split('filename=')[1]
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})


     }




    },
    select(selection, row){
      this.importList=selection

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


    formLIst(){
      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'/api/platform-head-icon-check/getList',
  headers:{
    tokenId:this.adder
        },
  params:this.formInline
    // current: this.formInline.current,s
    // size: this.formInline.size,
    // accountListReqVO




}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
        // .then(res => {
        //   console.log(res);
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.listData = res.data
        //     // 分页赋值
        //     this.pageparm.currentPage = this.formInline.current
        //     this.pageparm.pageSize = this.formInline.size
        //     this.pageparm.total = res.count
        //   }
        // })
        // .catch(err => {
        //   this.loading = false
        //   this.$message.error('菜单加载失败，请稍后再试！')
        // })
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.dialogForm{
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: left;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  .dialogFormChl{
    margin-top: 20px;
     margin-left:20px;
    /* flex: 1; */
    width: 22%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }
  .dialogFormChl img{
   width: 100%;
   height: 200px;
  }
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/system/girLimg.vue